import { ApplicationState } from 'application/redux';
import { resetMultipleSearchState, setListValues } from 'core/multiple-search/redux/action';
import { connect } from 'react-redux';
import ActivityLogComponent from './activity-log-component';
import { cancelLog, changePageActivityLog, fetch } from './redux/actions';

const mapStateToProps = (state: ApplicationState, ownProps: any) => ({
  activityLog: state.devices.detail.activityLog,
  general: state.devices.detail.general,
  hhid: ownProps.hhid,
  id: ownProps.id,
  overview: state.devices.detail.overview,
  t: state.i18n.t,
  pagination: state.pagination,
  offset: state.application.offset
});

export default connect(mapStateToProps, {
  fetch,
  cancelLog,
  setListValues,
  changePageActivityLog,
  resetMultipleSearchState
})(ActivityLogComponent);
